import React from "react";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import { useEditProduct } from "./products/edit-product/hooks/useEditProduct";
import { useFormHandlers } from "./products/edit-product/hooks/useFormHandlers";
import EditProductFields from "./products/edit-product/components/EditProductFields";
import EditProductActions from "./products/edit-product/components/EditProductActions";
import { ModalWrapper } from "src/shared/components/ModalWrapper";
import { EditProductProps } from "src/shared/services/interfacev2";

const EditProduct: React.FC<EditProductProps> = (props) => {
  const editHook = useEditProduct(props);
  const formHandlers = useFormHandlers({
    formData: editHook.formData,
    handleInputChange: editHook.handleInputChange,
    removeEmojis: editHook.removeEmojis,
    formatAmount: editHook.formatAmount,
  });

  const isUpdateEnabled = editHook.hasChanges && editHook.isFormValid && !editHook.isLoading;

  if (!props.open) return null;

  return (
    <ModalWrapper title="Edit Product" onClose={props.onClose} showCloseButton width="max-w-xl">
      <div className="space-y-6">
        <EditProductFields
          {...{
            ...editHook,
            ...formHandlers,
            businessType: props.businessType,
            showReorderPosition: props.showReorderPosition,
            getCategoryInitials: editHook.getCategoryInitials,
            updateProductNameWithCategory: editHook.updateProductNameWithCategory,
            // Pass barcode props from hook
            barcodeId: editHook.formData?.barcodeId || props.product?.barcodeId || "",
            barcodeMode: editHook.barcodeMode ?? false,
            scanMode: editHook.scanMode ?? false,
            onToggleScan: editHook.handleToggleScan,
            onBarcodeDetected: editHook.handleBarcodeDetected,
          }}
        />

        <EditProductActions 
          onClose={props.onClose} 
          onUpdate={editHook.handleUpdate} 
          isUpdateEnabled={isUpdateEnabled} 
        />
      </div>

      {editHook.isLoading && <LoadingScreen />}
    </ModalWrapper>
  );
};

export default EditProduct;